export default ($http) => ({
  getReportsList (query) {
    return $http.get('saved-reports', { query })
  },
  createSavedReport (body, params = {}) {
    return $http.post('saved-reports', { body, ...params })
  },
  getSavedReport (id) {
    return $http.get(`saved-reports/${id}`)
  },
  updateSavedReport (id, body) {
    return $http.put(`saved-reports/${id}`, { body })
  },
  deleteSavedReport (id) {
    return $http.delete(`saved-reports/${id}`)
  },
  deleteMultiple (ids) {
    return $http.delete('saved-reports/bulk', { body: { ids } })
  },
  getReportTypes () {
    return $http.get('saved-reports-types')
  },
  copySavedReport (id, body) {
    return $http.post(`saved-reports-copy/${id}`, { body })
  },
  shareSavedReport (id, payload) {
    return $http.post(`share/savedReport/${id}`, { body: payload })
  }
})
